import React, { FC, ReactElement } from 'react'
import { CopyFilled, DeleteFilled } from '@ant-design/icons'
import './data-control-row.scss'

import { Flex, Space, Tooltip } from 'antd'
import { FormLayoutRow } from '@pushly/aqe/lib/components'

type LayoutRowWithActionsProps = {
    dataItem: ReactElement
    onCopy?: (ev: React.MouseEvent) => void
    onDelete?: () => void
    readonly?: boolean
}

export const LayoutRowWithActions: FC<LayoutRowWithActionsProps> = ({ dataItem, onCopy, onDelete, readonly }) => {
    return (
        <Flex justify="space-between" className="data-control-row">
            <div className="data-control-item">
                <FormLayoutRow value={dataItem} />
            </div>
            {!readonly && (
                <Space className="data-control-row-actions">
                    {onCopy && (
                        <Tooltip title="Duplicate" placement="top">
                            <CopyFilled className="copy action-item" onClick={onCopy} />
                        </Tooltip>
                    )}
                    {onDelete && (
                        <Tooltip title="Remove" placement="top">
                            <DeleteFilled className="remove action-item" onClick={onDelete} />
                        </Tooltip>
                    )}
                </Space>
            )}
        </Flex>
    )
}

export const WellItemActions = ({ dataItem, onCopy, onDelete, readonly }) =>
    !readonly ? (
        <Space className="data-control-row-actions">
            {onCopy && (
                <Tooltip title="Duplicate" placement="top">
                    <CopyFilled className="copy action-item" onClick={onCopy} />
                </Tooltip>
            )}
            {onDelete && (
                <Tooltip title="Remove" placement="top">
                    <DeleteFilled className="remove action-item" onClick={onDelete} />
                </Tooltip>
            )}
        </Space>
    ) : null
